<template>
  <svg width="20" height="20" viewBox="0 0 20 20">
    <path
      d="M11.094 13.125a.781.781 0 1 1 0 1.563H8.906a.781.781 0 1 1 0-1.563h2.188zm2.5-3.75a.781.781 0 1 1 0 1.563H6.406a.781.781 0 1 1 0-1.563h7.188zm2.5-3.75a.781.781 0 1 1 0 1.563H3.906a.781.781 0 0 1 0-1.563h12.188z"
      fill="#000"
      fill-rule="evenodd"
    />
  </svg>
</template>
